<template>
  <div class="modal-actions">
    <div v-if="showSelection" class="modal-actions__selection">
      <span class="modal-actions__selection-summary" :data-testid="TestId.canonicalUpdate.selectionSummary">
        {{ store.selectionSummary }}
      </span>

      <!-- Off, an unchecked row is left for a later review; on, the import records its rejection. -->
      <sp-checkbox
        v-model="store.rejectExcluded"
        class="modal-actions__reject-excluded"
        :label="store.labels.rejectExcludedLabel"
        :disabled="store.isSubmitting"
        :data-testid="TestId.canonicalUpdate.rejectExcluded"
      ></sp-checkbox>
    </div>

    <sp-button
      variant="outlined"
      color="primary"
      :disabled="store.isSubmitting"
      :data-testid="TestId.canonicalUpdate.cancelButton"
      @click="store.close()"
    >
      {{ store.labels.cancel }}
    </sp-button>

    <sp-button
      variant="flat"
      color="primary"
      :disabled="store.confirmDisabled"
      :data-testid="TestId.canonicalUpdate.confirmButton"
      @click="store.confirm()"
    >
      {{ store.labels.confirm }}
    </sp-button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { useCanonicalUpdateStore } from "#ce/apps/SpAdmin/SpCanonicalUpdateApp/store/canonical-update";

const store = useCanonicalUpdateStore();

// The summary and the reject toggle describe the checkboxes, so they show only while a row carries one.
const showSelection = computed(() => store.actionableRows.length > 0);
</script>

<style scoped lang="scss">
.modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-ref-scale-8);
  width: 100%;
  padding-block: var(--sp-ref-scale-16);
  padding-inline: var(--sp-ref-scale-24);
  border-top: var(--sp-sys-border-width-default) solid var(--sp-sys-color-outline);

  /* SpButton reads -background-color (not -background); without these the
   * disabled Confirm button renders transparent — i.e. invisible until its
   * preconditions enable it. The button must always be visible, just disabled. */
  --sp-comp-button-disabled-background-color: var(--sp-sys-color-disabled);
  --sp-comp-button-disabled-text-color: var(--sp-sys-color-on-disabled);

  &__selection {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--sp-ref-scale-4) var(--sp-ref-scale-16);
    margin-right: auto;
  }

  &__selection-summary {
    font-size: var(--sp-sys-typescale-small-font-size);
    color: var(--sp-sys-color-on-surface-variant);
  }
}
</style>
